import { AppOptimizelyProvider } from './AppOptimizelyProvider'
import { AtlasProvider } from '@dtx-company/inter-app/src/hoc/atlas-provider/provider'
import { FC, ReactNode } from 'react'
import { FlowSWRConfig } from '@dtx-company/inter-app/src/components/FlowSWRConfig'
import { HooksRequiringProviders } from './HooksRequiringProviders'
import { ImpactSync } from './Impact'
import { PersistGate } from 'redux-persist/integration/react'
import { ProfitWell } from './ProfitWell'
import { SessionAndOptimizelyValues } from '../types'
import { StyleSheetManager } from 'styled-components'
import { XStateProvider } from './XStateProvider'
import { persistor } from '@dtx-company/inter-app/src/redux/persistor'
import isPropValid from '@emotion/is-prop-valid'

export type PageProvidersProps = {
  swrFallback?: Record<string, unknown>
} & SessionAndOptimizelyValues

export const PageProviders: FC<PageProvidersProps & { children: ReactNode }> = ({
  children,
  swrFallback,
  session,
  optimizely,
  ...pageProps
}) => {
  return (
    <StyleSheetManager
      enableVendorPrefixes
      shouldForwardProp={(propName, elementToBeRendered) => {
        return typeof elementToBeRendered === 'string' ? isPropValid(propName) : true
      }}
      // https://github.com/styled-components/styled-components/issues/4071#issuecomment-1625465480
      {...pageProps}
    >
      <FlowSWRConfig fallback={swrFallback}>
        <AppOptimizelyProvider session={session} optimizely={optimizely}>
          <AtlasProvider>
            <HooksRequiringProviders session={session} />
            <XStateProvider
              isMobile={optimizely?.attributes?.deviceType !== 'desktop'}
              {...pageProps}
            >
              <PersistGate loading={children} persistor={persistor}>
                {children}
                <ImpactSync />
                <ProfitWell />
              </PersistGate>
            </XStateProvider>
          </AtlasProvider>
        </AppOptimizelyProvider>
      </FlowSWRConfig>
    </StyleSheetManager>
  )
}
